import Breadcrumb from "atoms/breadcrumbs/breadcrumb";
import React from "react";

const SupportUserDetailBreadcrumb: React.FC = () => (
    <Breadcrumb>
        <span className="c-breadcrumb__label">Subscriber</span>
    </Breadcrumb>
);

export default SupportUserDetailBreadcrumb;
